import type { ReactElement } from 'react';
import { pxToRem } from '@/theme/spacing';
import { PieChartLegend } from './PieChartLegend';
import { PieChartSvg } from './PieChartSvg';
import type { PieChartHoverChange, PieChartRenderModel } from './piechart-types';
interface PieChartContentProps {
    renderModel: PieChartRenderModel;
    hoveredIndex: number | null;
    onHoveredIndexChange: PieChartHoverChange;
    pieChartIdPrefix: string;
}
export function PieChartContent({ renderModel, hoveredIndex, onHoveredIndexChange, pieChartIdPrefix, }: PieChartContentProps): ReactElement {
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: pxToRem(24),
            flexWrap: 'wrap',
            justifyContent: 'center',
        }}>
        <PieChartSvg hoveredIndex={hoveredIndex} onHoveredIndexChange={onHoveredIndexChange} pieChartIdPrefix={pieChartIdPrefix} renderModel={renderModel}/>

        <PieChartLegend arcs={renderModel.arcs} hoveredIndex={hoveredIndex} onHoveredIndexChange={onHoveredIndexChange}/>
      </div>
    );
}
